// Reduc
import 
{ 	
	createStore, 
	combineReducers
} from "redux";

/*  Auth Handler */
	
	// initial State
	const initialStateAuth = {
		user : '',
		loading : false,
		error : '',
	};

	// Action 
	const USER_NOT_AUTHENTICATED = 'USER_NOT_AUTHENTICATED' ;
	const USER_AUTH_REQUEST      = 'USER_AUTH_REQUEST'      ;
	const USER_AUTH_SUCCESS		 = 'USER_AUTH_SUCCESS'      ;
	const USER_AUTH_ERROR        = 'USER_AUTH_ERROR'		;

	export const userNotAuthenticated = () => {
		return {
			type : USER_NOT_AUTHENTICATED,
		}
	}

	export const userAuthRequest = () => {
		return {
			type : USER_AUTH_REQUEST,
		}
	}

	export const userAuthSuccess = (user) => {
		return {
			type : USER_AUTH_SUCCESS,
			payload : user
		}
	}

	export const userAuthFailed = (error) => {
		return {
			type : USER_AUTH_ERROR,
			payload : error,
		}
	}

	// reducer
	const authReducer = (state = initialStateAuth, action) => {
		switch(action.type){

			case USER_NOT_AUTHENTICATED : return state ;

			case USER_AUTH_REQUEST : return {
				...state,
				loading : true,
			} 

			case USER_AUTH_SUCCESS : 
			return {
				...state,
				loading : false,
				user : action.payload,
				error : ''
			}

			case USER_AUTH_ERROR : return {
				...state,
				error : action.payload
			}

			default : return state;
		}
	}

/* Game-UI-Data */

	const APP_NAME = "GammyWood";
	
	const initialAppData = {
		appName : APP_NAME,
		pages : ['Logout'],
		settings : [''],
		searchText : "Find",
	};

	const appReducer = (state = {initialAppData}, action) => {
		switch(action.type){
		}

		return state;
	};

/* API-Data-Fetching */

	// initial State
	const initialAPIData = {
		method: 'GET',
		headers: {
			'X-RapidAPI-Key': 'b233a100dbmsh18e3849d90fc949p1a598bjsn66464bdd9935',
			'X-RapidAPI-Host': 'free-to-play-games-database.p.rapidapi.com'
		},
		url : 'https://free-to-play-games-database.p.rapidapi.com/api/games',
		gamedata : [], 
		isDataFetched : false,
		error : '',
		genres : [],
		platform : [],
		filteredData : [],
		platformText : 'all',
		genreText : 'all',
		searchText : '',
	};


	// Actions

	const API_DATA_REQUEST = 'API_DATA_REQUEST';
	const API_DATA_SUCCESS = 'API_DATA_SUCCESS';
	const API_DATA_ERROR   = 'API_DATA_ERROR';
	const API_GENRES_SUCCESS = 'API_GENRES_SUCCESS';
	const API_PLATFORM_SUCCESS = 'API_PLATFORM_SUCCESS';
	const FILTERED_DATA = 'FILTERED_DATA';
	const GENRE_SELECTED = 'GENRE_SELECTED' ;
	const PLATFORM_SELECTED = 'PLATFORM_SELECTED' ;
	const SEARCH_TEXT_FILTER = 'SEARCH_TEXT_FILTER';

	export const genreSelected = (data) => {
		return {
			type : GENRE_SELECTED,
			payload : data,
		}
	}

	export const platformSelected = (data) => {
		return {
			type : PLATFORM_SELECTED,
			payload : data,
		}
	}

	export const searchTextFilter = (data) => {
		return {
			type : SEARCH_TEXT_FILTER,
			payload : data,
		}
	}

	export const APIDataRequest = () => {
		return {
			type : API_DATA_REQUEST,
		}
	};

	export const APIDataSuccess = (data) => {
		return {
			type : API_DATA_SUCCESS,
			payload : data,
		}
	}

	export const APIDataError = (error) => {
		return {
			type : USER_AUTH_ERROR,
			payload : error,
		}
	}

	export const APIGenresSuccess = (data) => {
		return {
			type : API_GENRES_SUCCESS,
			payload : data, 
		}
	}

	export const APIPlatformSuccess = (data) => {
		return {
			type : API_PLATFORM_SUCCESS,
			payload : data, 
		}
	}

	export const FilteredData = (data) => {
		return {
			type : FILTERED_DATA,
			payload : data, 
		}
	}


	// Reducer 
	const apiDataReducer = (state = initialAPIData, action) => {

		switch(action.type){

			case API_DATA_REQUEST : return state ;

			case API_DATA_SUCCESS : return {
				...state,
				gamedata : action.payload,
				filteredData : action.payload,
				isDataFetched : true,
			}

			case API_DATA_ERROR : return {
				...state,
				error : action.payload,
				isDataFetched : false,
			}

			case API_GENRES_SUCCESS : return {
				...state,
				genres : action.payload,
			}

			case API_PLATFORM_SUCCESS : return {
				...state,
				platform : action.payload,
			}

			case FILTERED_DATA : return {
				...state,
				filteredData : action.payload,
			}

			case GENRE_SELECTED : return {
				...state,
				genreText : action.payload,
			}

			case PLATFORM_SELECTED : return {
				...state,
				platformText : action.payload,
			}

			case SEARCH_TEXT_FILTER : return {
				...state,
				searchText : action.payload,
			}
		}

		return state;
	};

/* Store */

	// store
	const rootReducer = combineReducers({
		Auth : authReducer,
		App : appReducer,
		API : apiDataReducer,
	});
	const store = createStore(rootReducer);
	store.subscribe(()=>{});

	export default store;


